<template>
  <section class="section section-shaped section-lg my-0">
    <div class="container pt-lg-md">
      <div class="row justify-content-center">
        <div class="col-lg-10">
          <card
            type="secondary"
            shadow
            header-classes="bg-white pb-5"
            body-classes="px-lg-5 py-lg-5"
            class="border-0"
          >
            <template>
              <div class="text-muted text-center mb-12">
                <h5 style="padding-bottom: 20px">Actualizar Perfil</h5>
              </div>
              <div class="text-center" v-if="loading">
                <img style="max-height: 70px;" v-bind:src="'./img/custom/loading.svg'" />Loading...
              </div>
            </template>
            <template>
              <form id="registro" @submit.prevent="validateForm">
                <div class="row">
                  <div class="col-12" v-if="errors.length">
                    <div>
                      <base-alert type="default">
                        <span class="alert-inner--icon">
                          <i class="ni ni-bell-55"></i>
                        </span>
                        <span class="alert-inner--text">
                          <ul style="margin: 0px;">
                            <li v-for="error of errors" v-bind:key="error">{{ error }}</li>
                          </ul>
                        </span>
                      </base-alert>
                    </div>
                  </div>
                  <div class="col-12" role="form">
                    <div class="row">
                      <div class="col-lg-6 col-ls-12">
                        <base-input
                          alternative
                          class="mb-3"
                          placeholder="Nombres"
                          v-model="user.first_name"
                        ></base-input>
                      </div>
                      <div class="col-lg-6 col-ls-12">
                        <base-input
                          alternative
                          class="mb-3"
                          placeholder="Apellidos"
                          v-model="user.last_name"
                        ></base-input>
                      </div>
                      <div class="col-lg-6 col-ls-12">
                        <select class="form-control" v-model="user.identification_type">
                          <option value selected disabled>Tipo de identificación</option>
                          <option
                            v-for="identification_type in identification_types"
                            v-bind:key="identification_type"
                          >{{identification_type}}</option>
                        </select>
                      </div>
                      <div class="col-lg-6 col-ls-12">
                        <base-input
                          alternative
                          class="mb-3"
                          placeholder="Documento de identificación"
                          v-model="user.identification_number"
                          disabled
                        ></base-input>
                      </div>
                      <div class="col-lg-6 col-ls-12">
                        <base-input
                          alternative
                          class="mb-3"
                          placeholder="Fecha de nacimiento (AAAA-MM-DD)"
                          v-model="user.birth_date"
                        ></base-input>
                      </div>
                      <div class="col-lg-6 col-ls-12">
                        <base-input
                          alternative
                          class="mb-3"
                          type="email"
                          placeholder="Correo electrónico"
                          v-model="user.email"
                          disabled
                        ></base-input>
                      </div>
                      <div class="col-lg-6 col-ls-12">
                        <select class="form-control" v-model="user.gender">
                          <option value selected disabled>Género</option>
                          <option>Masculino</option>
                          <option>Femenino</option>
                          <option>Otro</option>
                        </select>
                      </div>
                      <div class="col-lg-6 col-ls-12">
                        <div class="form-group">
                          <select class="form-control" v-model="user.sector">
                            <option value selected disabled>Comuna</option>
                            <option
                              v-for="sector in sectors"
                              v-bind:key="sector.id"
                              :value="sector"
                            >{{sector.name}}</option>
                          </select>
                        </div>
                      </div>
                      <div class="col-lg-6 col-ls-12">
                        <base-input
                          alternative
                          class="mb-3"
                          placeholder="Teléfono"
                          v-model="user.phone"
                        ></base-input>
                      </div>
                    </div>
                    <div class="col-ls-12">
                      <p>Si deseas actualizar tu correo electrónico o numero de identificación por favor escribenos al correo: <a href="mailto:soporte.masvivos@medellinjoven.com">soporte.masvivos@medellinjoven.com</a></p>
                    </div>
                    <div class="text-center">
                      <base-button
                        nativeType="submit"
                        type="primary"
                        class="my-4"
                        :disabled="loading"
                      >
                        <span v-if="!updating">Actualizar</span>
                        <span v-if="updating">Actualizando...</span>
                      </base-button>
                    </div>
                  </div>
                </div>
              </form>
            </template>
            <template></template>
          </card>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
const AmazonCognitoIdentity = require("amazon-cognito-identity-js");
const axios = require("axios");
const moment = require("moment");

export default {
  data() {
    return {
      errors: [],
      loading: false,
      updating: false,
      sectors: [
        {
          id: 1,
          name: "Comuna 1 - Popular"
        },
        {
          id: 2,
          name: "Comuna 2 - Santa Cruz"
        },
        {
          id: 3,
          name: "Comuna 3 - Manrique"
        },
        {
          id: 4,
          name: "Comuna 4 - Aranjuez"
        },
        {
          id: 5,
          name: "Comuna 5 - Castilla"
        },
        {
          id: 6,
          name: "Comuna 6 - Doce de Octubre"
        },
        {
          id: 7,
          name: "Comuna 7 - Robledo"
        },
        {
          id: 8,
          name: "Comuna 8 - Villa Hermosa"
        },
        {
          id: 9,
          name: "Comuna 9 - Buenos Aires"
        },
        {
          id: 10,
          name: "Comuna 10 - La Candelaria"
        },
        {
          id: 11,
          name: "Comuna 11 - Laureles Estadio"
        },
        {
          id: 12,
          name: "Comuna 12 - La América"
        },
        {
          id: 13,
          name: "Comuna 13 - San Javier"
        },
        {
          id: 14,
          name: "Comuna 14 - El Poblado"
        },
        {
          id: 15,
          name: "Comuna 15 - Guayabal"
        },
        {
          id: 16,
          name: "Comuna 16 - Belén"
        },
        {
          id: 50,
          name: "Comuna 50 - Corregimiento de San Sebastián de Palmitas"
        },
        {
          id: 60,
          name: "Comuna 60 - Corregimiento de San Cristóbal"
        },
        {
          id: 70,
          name: "Comuna 70 - Corregimiento de Altavista"
        },
        {
          id: 80,
          name: "Comuna 80 - Corregimiento de San Antonio de Prado"
        },
        {
          id: 90,
          name: "Comuna 90 - Corregimiento de Santa Elena"
        },
        {
          id: 100,
          name: "Otro municipio"
        }
      ],
      identification_types: [
        "Cédula",
        "Pasaporte",
        "Registro de Nacimiento",
        "Tarjeta de Identidad"
      ],
      user: {
        first_name: "",
        last_name: "",
        identification_type: "",
        identification_number: "",
        birth_date: "",
        email: "",
        gender: "",
        sector: "",
        phone: ""
      }
    };
  },
  methods: {
    async validateForm() {
      this.errors = [];

      // Required
      if (!this.user.identification_number)
        this.errors.push("El número de identificación es obligatorio");
      if (!this.user.first_name) this.errors.push("El nombre es obligatorio");
      if (!this.user.last_name) this.errors.push("El apellido es obligatorio");
      if (!this.user.identification_type)
        this.errors.push("El tipo de identificación es obligatorio");
      if (!this.user.birth_date)
        this.errors.push("La fecha de nacimiento es obligatoria");
      if (!this.user.email)
        this.errors.push("El correo electrónico obligatorio");
      if (!this.user.gender) this.errors.push("El género es obligatorio");
      if (!this.user.sector) this.errors.push("La comuna es obligatoria");

      if (this.errors.length) {
        return false;
      }

      if (!/^[0-9a-zA-Z_]{1,16}$/.test(this.user.identification_number))
        this.errors.push("El número de identificación es incorrecto");

      if (
        !/^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/.test(
          this.user.email
        )
      )
        this.errors.push("El correo electrónico es incorrecto");

      if (
        !/^(19|20){1}[0-9]{2}\-[0-9]{2}\-[0-3]{1}[0-9]{1}$/.test(
          this.user.birth_date
        ) ||
        isNaN(Date.parse(this.user.birth_date))
      ) {
        this.errors.push(
          "La fecha de nacimiento es incorrecta, el formato es AAAA-MM-DD"
        );
      } else {
        if (moment().diff(this.user.birth_date, "years") > 28) {
          alert(
            "Hola, con esta tarjeta los jóvenes entre los 14 y 28 años de edad, podrán disfrutar de muchos beneficios y descuentos. Lastimosamente, te encuentras fuera de este rango de edad y en los establecimientos de nuestras marcas aliadas debes presentar tu documento de identidad por lo cual no podrás disfrutar de estos descuentos. Te invitamos a que le regales esta tarjeta a alguien cercano que esté dentro del rango de edades. ¡Gracias!"
          );
          this.user.birth_date = "";
        }
      }

      if (this.errors.length) {
        return false;
      } else {
        return this.updateProfile();
      }
    },
    async getUserInfo(){
      this.loading = true;

      let user = await this.$store.state.user;
      
      if (user) {
        var jwt = user
          .getSignInUserSession()
          .getIdToken()
          .getJwtToken();
      } else {
          return await this.getUserInfo();
      }

      let config = {
        headers: {
          Authorization: jwt
        }
      };

      try{
        let response = await axios.get(this.$store.state.api_url+'users/update-info', config);
        this.user = response.data;
      }catch(err){
        this.errors.push("Ocurrió un error intentando cargar tu información en el sistema");
      }
      this.loading = false;
    },
    async updateProfile() {
      this.loading = true;

      let user = this.$store.state.user;
      if (user) {
        var jwt = user
          .getSignInUserSession()
          .getIdToken()
          .getJwtToken();
      } else {
        return false;
      }

      let config = {
        headers: {
          'Authorization': jwt,
        },
        params: this.user
      };

      try {
        let response = await axios.post(this.$store.state.api_url+'users/update-info', this.user, {headers: config.headers});
        if(response.data == true){
          alert('Su información fue actualizada con éxito'); 
        }else{
          this.errors.push("Ocurrió un error al intentar actualizar su información");
        }
      } catch (err) {
        console.log(err);
        this.errors.push("Ocurrió un error al intentar actualizar su información");
      }
        this.loading = false;
    }
  },
  created(){
    this.getUserInfo();
  }
};
</script>
<style>
</style>
